export const PATHS = {
  ROOT: 'company-introductions',
  getOneById: (id: number) => `${PATHS.ROOT}/${id}`,
};
